import { render } from "./ShowParticipants1.vue?vue&type=template&id=4fcf1d6f&scoped=true"
import script from "./ShowParticipants1.vue?vue&type=script&lang=js"
export * from "./ShowParticipants1.vue?vue&type=script&lang=js"

import "./ShowParticipants1.vue?vue&type=style&index=0&id=4fcf1d6f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcf1d6f"]])

export default __exports__